import React, { Suspense } from 'react';
import { Navigate, Route } from 'react-router-dom';
import SentryRoutes from '../SentryRoutes';
import RouteLoading from './RouteLoading';
import { adminRouteConfig } from './routeConfig';

const AdminRoutes = () => {
    return (
        // The admin pages load on demand (routeConfig.js).
        <Suspense fallback={<RouteLoading />}>
            <SentryRoutes>
                {adminRouteConfig.map(({ path, component: Component }) => (
                    <Route key={path} path={path} element={<Component />} />
                ))}
                <Route path="*" element={<Navigate to="/admin" replace />} />
            </SentryRoutes>
        </Suspense>
    );
};

export default AdminRoutes;
